import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";
import html2canvas from "html2canvas";

import styles from "../styles/VideoList.module.css";
import { Dropdown } from "./dropdown/Dropdown";
import S3_BUCKET_URL from "../utils/constants";


const downloadQRCode = () => {
    const qrElement = document.getElementById("qr-code");
    if (!qrElement) return;

    html2canvas(qrElement, { scale: 5 }).then((canvas) => {
        const link = document.createElement("a");
        link.href = canvas.toDataURL("image/png", 1.0);
        link.download = "qr_code.png";
        link.click();
    });
};

const VideoList = () => {
    const [selectedVideo, setSelectedVideo] = useState(null);
    const [selectedLanguage, setSelectedLanguage] = useState(() => {
        return sessionStorage.getItem("selectedLanguage") || "English";
    });

    const navigate = useNavigate();

    const VIDEOS_BY_LANGUAGE = {
        English: [
            { name: "toca-intro-en.mp4" },
            { name: "toca-rpm-services-en.mp4" },
            { name: "toca-ccm-services-en.mp4" },
        ],
        Spanish: [
            { name: "toca-rpm-services-sp.mp4" },
            { name: "toca-ccm-services-sp.mp4" },
        ],
    };

    const videos = VIDEOS_BY_LANGUAGE[selectedLanguage] || [];

    const options = [
        { value: "English", label: "English" },
        { value: "Spanish", label: "Spanish" },
    ];

    const handleLenguageSelect = (value) => (
        setSelectedLanguage(value)
    );

    useEffect(() => {
        sessionStorage.setItem("selectedLanguage", selectedLanguage);
    }, [selectedLanguage]);


    return (
        <div className={styles.page_container}>
            <h2>Available Videos</h2>

            <p style={{ marginBottom: "5px" }}>Select Language</p>
            <Dropdown
                options={options}
                value={selectedLanguage}
                onChange={(value) => handleLenguageSelect(value)}
                placeholder="Select language"
            />

            <div className={styles.videoGrid}>
                {videos?.map((video, index) => {
                    const videoUrl = `${S3_BUCKET_URL}videos/${video.name}`;
                    const thumbnailUrl = `${S3_BUCKET_URL}thumbnails/${video.name.replace(".mp4", ".webp")}`;

                    return (
                        <div key={index} className={styles.videoCard}>
                            <img src={thumbnailUrl} alt="Thumbnail" className={styles.thumbnail} />
                            <div className={styles.actions}>
                                {/* <button onClick={() => setSelectedVideo(`https://main.d2uueztqbmhk14.amplifyapp.com/watch/${encodeURIComponent(video.name.replace(".mp4", ""))}`)} className={styles.qrButton}>
                                    Scan QR Code
                                </button> */}
                                <button onClick={() => navigate(`/watch/${encodeURIComponent(video.name.replace(".mp4", ""))}`)} className={styles.playButton}>
                                    Play Video
                                </button>
                            </div>
                        </div>
                    );
                })}
            </div>

            {/* QR Code Modal */}
            {selectedVideo && (
                <div className={styles.modalOverlay} onClick={() => setSelectedVideo(null)}>
                    <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>

                        <div className={styles.qr_code_wrapper}>
                            <div className={styles.qr_code_box} id="qr-code">
                                <QRCodeSVG value={selectedVideo} size={250} bgColor={"#FFFFFF"} fgColor={"#1E40AF"} level={"H"} />
                            </div>
                            <p className={styles.scan_text}>Scan to watch video</p>
                        </div>

                        <button className={styles.downloadButton} onClick={downloadQRCode}>Download QR Code</button>
                        <button className={styles.closeButton} onClick={() => setSelectedVideo(null)}>Close</button>
                    </div>
                </div>
            )}

        </div>
    );
};

export default VideoList;
